module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/kobe_sns_06-fbd26b2132c8a97dbac42c07aa564ad9.jpg";